var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction-line"},[_c('div',{staticClass:"icon-btn instruction-icon"},[_c('button',[_c('font-awesome-icon',{attrs:{"icon":_vm.instruction.icon}})],1)]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.instruction.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }